/**
 * Agrupamento dos status de proposta exibidos nos cards e no filtro de status.
 * Cada grupo reúne um ou mais códigos de `StatusPortal` (mesmos códigos usados
 * em `proposalStatusConfig` e no backend). O valor do filtro é a lista de
 * códigos separada por vírgula (consumida pelo `InConditions.StatusPortal`).
 */
export interface ProposalStatusGroup {
  key: string;
  label: string;
  /** Códigos de StatusPortal agrupados neste bucket. */
  codes: string[];
}

export const PROPOSAL_STATUS_GROUPS: ProposalStatusGroup[] = [
  { key: 'filling', label: 'Em preenchimento', codes: ['6'] },
  { key: 'signature', label: 'Em assinatura', codes: ['12'] },
  { key: 'analysis', label: 'Em análise', codes: ['9', '18'] },
  // O 7 (`ProposalAccepted`) tem grupo próprio: o rótulo dele no enum é
  // "Efetivada", e agrupá-lo sob "Transmitida" (rótulo do 8) fazia a linha e o
  // filtro dizerem coisas diferentes. Vale para todo produto — RD Equipamentos
  // usa o código 8 diretamente para `aceita` (proposta transmitida, aguardando
  // emissão manual do i4Pro), então cai no grupo 'transmitted' abaixo.
  { key: 'accepted', label: 'Efetivada', codes: ['7'] },
  { key: 'transmitted', label: 'Transmitida', codes: ['8', '10'] },
  { key: 'cancelled', label: 'Encerrada', codes: ['11', '15', '19', '21'] },
];

/** Valor usado no filtro `status` (lista de códigos separada por vírgula). */
export const groupStatusValue = (group: ProposalStatusGroup): string =>
  group.codes.join(',');
